import { render, staticRenderFns } from "./milestone-plan-onboarding-dialog-content--first-page.vue?vue&type=template&id=4e97d668&scoped=true&"
import script from "./milestone-plan-onboarding-dialog-content--first-page.vue?vue&type=script&lang=ts&"
export * from "./milestone-plan-onboarding-dialog-content--first-page.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-plan-onboarding-dialog-content--first-page.vue?vue&type=style&index=0&id=4e97d668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97d668",
  null
  
)

export default component.exports